import ContactActivity from 'react/pages/contacts/activity';

angular.module('gym').value('ContactActivity', ContactActivity);
